import React from 'react'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../../models/AiResult'
import { EditableTextMeetingResult } from './EditableTextMeetingResult'
import { EditableListMeetingResult } from './EditableListMeetingResult'
import { EditableMapMeetingResult } from './EditableMapMeetingResult'
import { getSafeValueOnPath } from '../../../utils'
import { EditableBooleanMeetingResult } from './EditableBooleanMeetingResult'

export interface StructuredSummaryMeetingResultEditViewProps {
  aiFeature: AiFeature
  aiResult: AiResult
  basePath?: string
  path?: string
  onResultTextContentChange: (basePath: string, path: string, resultTextContent: string | boolean) => void
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
}

export const StructuredSummaryMeetingResultEditView: React.FC<StructuredSummaryMeetingResultEditViewProps> = ({
  aiResult,
  aiFeature,
  basePath = '$',
  path = '$.result',
  onResultTextContentChange,
  onFormattedResultChange,
}) => {
  const result = getSafeValueOnPath(getSafeValueOnPath(aiResult.result, basePath), path)

  if (typeof result === 'boolean') {
    return <EditableBooleanMeetingResult result={result} basePath={basePath} path={path} onResultTextContentChange={onResultTextContentChange} />
  }

  if (!result) {
    return (
      <EditableTextMeetingResult
        aiResult={aiResult}
        basePath={basePath}
        path={path}
        onResultTextContentChange={onResultTextContentChange}
        onFormattedResultChange={onFormattedResultChange}
      />
    )
  }

  if (Array.isArray(result)) {
    return (
      <EditableListMeetingResult
        aiResult={aiResult}
        aiFeature={aiFeature}
        basePath={basePath}
        path={path}
        onResultTextContentChange={onResultTextContentChange}
        onFormattedResultChange={onFormattedResultChange}
      />
    )
  }

  if (typeof result === 'object') {
    return (
      <EditableMapMeetingResult
        aiResult={aiResult}
        aiFeature={aiFeature}
        basePath={basePath}
        path={path}
        onResultTextContentChange={onResultTextContentChange}
        onFormattedResultChange={onFormattedResultChange}
      />
    )
  }

  return (
    <EditableTextMeetingResult
      aiResult={aiResult}
      basePath={basePath}
      path={path}
      onResultTextContentChange={onResultTextContentChange}
      onFormattedResultChange={onFormattedResultChange}
    />
  )
}
